export const marketUrl = 'https://megamarket.ru/?utm_source=Piatnitsa&utm_medium=game&utm_campaign=PiatnitsaMMnovember'